module.exports = __webpack_public_path__ + "img/login-title.fe4aa3ca.png";